import { render } from "./reportInfo.vue?vue&type=template&id=27a87756&scoped=true"
import script from "./reportInfo.vue?vue&type=script&lang=js"
export * from "./reportInfo.vue?vue&type=script&lang=js"

import "./reportInfo.vue?vue&type=style&index=0&id=27a87756&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a87756"]])

export default __exports__